import React, { useState, useEffect } from "react";
import UserHeader from "./UserHeader";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get_Date } from "../../Utils/commonFunctions";
import {
  QuestionOption,
  AnalysisReportUserGraph,
  TextResponces,
} from "./commonComponent";

import {
  getSurveyAnalysisReportPreView,
  surveyDraftandreportRejection,
} from "../../Utils/adminFunctions";
import UserAnalysisReportDownload from "./UserAnalysisReportDownload";
import ScaleLoader from "react-spinners/ScaleLoader";

function UserAnalysisReport() {
  const navigate = useNavigate();
  const [surveyData, setSurveyData] = useState("");
  const [analysisReport, setAnalysisReport] = useState("");
  const [desabledBtn, setDesabledBtn] = useState(false);
  const [isCheckedUser, setIsCheckedUser] = useState(false);
  const [isNotifyUser, setIsNotifyUser] = useState(false);
  const [isCheckedAccess, setIsCheckedAccess] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { surveyID } = useParams();
  useEffect(() => {
    UserSurveyAnalysisReport();
  }, []);
  const UserSurveyAnalysisReport = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    const response = await getSurveyAnalysisReportPreView(bodyFormData);
    if (response.status == "success") {
      let colors = response.data.survey_result[0].COLOR;
      setIsNotifyUser(response.data.isNotifyUser);
      setIsCheckedUser(response.data.isCheckedUser);
      setIsCheckedAccess(response.data.isCheckedAccess);
      setSurveyData(response.data.survey_result[0]);
      if (Object.keys(response.data.anyreports).length === 0) {
        setAnalysisReport("");
      } else {
        let dataObject = response.data.anyreports;
        let isChart,
          options,
          reportChartsData,
          textResponcesData,
          tempChartData,
          tempTextResponces;
        let analysisReport = Object.keys(dataObject).map(function (key, index) {
          let questionType = dataObject[key].type;
          let isInclude = dataObject[key].isinclude;
          if (dataObject[key].reportscharts.length === 0) {
            isChart = 0;
            tempChartData = "";
          } else {
            isChart = 1;
            reportChartsData = dataObject[key].reportscharts;
            tempChartData = Object.keys(reportChartsData).map(function (
              key,
              index2
            ) {
              let item = reportChartsData[key];
              return (
                <div className="row mt-4 mb-0" key={index2}>
                  <AnalysisReportUserGraph reportsCharts={item} key={index2} />
                </div>
              );
            });
          }
          if (dataObject[key].options === "") {
            options = "";
          } else {
            options = dataObject[key].options;
          }
          if (dataObject[key].textresponse.length === 0) {
            tempTextResponces = "";
          } else {
            if (isInclude === 1) {
              textResponcesData = dataObject[key].textresponse;
              tempTextResponces = (
                <div className="row mb-4">
                  <div className="col-md-12 text-left">
                    <h6 className="p-0">
                      <strong>Text response</strong>
                    </h6>
                    {Object.keys(textResponcesData).map(function (key, index3) {
                      let TextitemData = textResponcesData[key];
                      return (
                        <TextResponces
                          label={TextitemData.label}
                          key={index3}
                          textResponseItem={TextitemData.textresponseitem}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            } else {
              tempTextResponces = "";
            }
          }
          return (
            <div className="row" key={index}>
              <div className="col-md-12">
                <div className="sar-question p-1">
                  <div className="sar-question-number">{index + 1}</div>
                  <span className="sar-question-text">
                    {dataObject[key].label}
                    {dataObject[key].type === "survey"
                      ? " > " + dataObject[key].survey_label
                      : ""}
                  </span>
                </div>
                {(questionType === "radio" ||
                  questionType === "selectboxes" ||
                  questionType === "survey") && (
                  <QuestionOption
                    questionType={questionType}
                    isChart={isChart}
                    options={options}
                    colors={colors}
                  />
                )}
              </div>
              {tempChartData}
              {tempTextResponces != "" && tempTextResponces}
            </div>
          );
        });
        setAnalysisReport(analysisReport);
      }
    }
  };

  const handleRejectSurveyStatus = async (surveyStatus) => {
    setDesabledBtn(true);
    if (message === "") {
      setErrorMessage("Can not be empty");
      setDesabledBtn(false);
      return false;
    } else {
      const status =
        surveyStatus == "survey_rejected" ? "rejected" : "approved";
      const bodyFormData = new FormData();
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("comment", message);
      bodyFormData.append("status", status);
      bodyFormData.append("action", surveyStatus);
      const response = await surveyDraftandreportRejection(bodyFormData);
      if (response.status == "success") {
        document.querySelector(".close_popup").click();
        document.querySelector(".close_popup_reject").click();
        UserSurveyAnalysisReport();
        setDesabledBtn(false);
        toast.success(response.message, { autoClose: 1500 });
        /*setTimeout(function () {
          navigate("/UserListSurveys/");
        }, 2000);*/
      } else {
        setDesabledBtn(false);
        toast.warning(response.message, { autoClose: 1500 });
      }
    }
  };
  return (
    <div>
      {desabledBtn&&(
        <div style={{
          zIndex:100000,
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          position: "fixed",
         inset:0,
          backgroundColor: 'rgba(86, 86, 86, 0.8)'
        }}>
        <ScaleLoader
  color="#F58634"
  height={100}
  margin={5}
  radius={8}
  width={20}
/>
        </div>
      )}
      <UserHeader />
     
      <div className="modal fade show" id="approve_report" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Approve survey analysis report? </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div class="form-group">
                <label for="validationTextarea" className="form-label">
                  Comments:
                </label>

                <textarea
                  className={
                    "form-control" + (errorMessage ? " is-invalid" : "")
                  }
                  id="message-text"
                  onChange={(e) => {
                    setMessage(e.target.value);
                    setErrorMessage("");
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark close_popup"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm custom-btn-primary"
                onClick={() => {
                  handleRejectSurveyStatus("survey_approved");
                }}
                disabled={desabledBtn}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade show" id="reject_report" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Reject survey analysis report?</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div class="form-group">
                <label for="validationTextarea" className="form-label">
                  Comments:
                </label>

                <textarea
                  className={
                    "form-control" + (errorMessage ? " is-invalid" : "")
                  }
                  id="message-text"
                  onChange={(e) => {
                    setMessage(e.target.value);
                    setErrorMessage("");
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark close_popup_reject"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm custom-btn-primary"
                onClick={() => {
                  handleRejectSurveyStatus("survey_rejected");
                }}
                disabled={desabledBtn}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade show" id="modal-chart" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body"></div>
          </div>
        </div>
      </div>
      <div className="modal fade show" id="modal-default" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm delete</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this record?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-sm btn-danger">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row mt-4">
          <div className="col-md-12">
            <div className="card vd-card response-list scrollbar-custom square thin">
              <p className="text-right m-2">
                <h3 className="card-title">
                  <UserAnalysisReportDownload />
                </h3>
                <h3 className="card-title pull-right ">
                  {localStorage.getItem("user_type") == 5 && (
                    <>
                      <Link
                        to={"/survey-analysis-report-approval"}
                        className="btn btn-sm custom-btn-primary pull-right"
                      >
                        <i className="fa fa-arrow-left"></i> Back
                      </Link>
                    </>
                  )}
                  {(localStorage.getItem("user_type") == 2 ||
                    localStorage.getItem("user_type") == 3) && (
                    <>
                      <Link
                        to={"/manufacturer-create-analysis/" + surveyID}
                        className="btn btn-sm custom-btn-primary pull-right"
                      >
                        <i className="fa fa-arrow-left"></i> Back
                      </Link>
                    </>
                  )}
                </h3>
              </p>

              <div className="card-body">
                <div className="row">
                  <div className="col-md-12" id="page">
                    <table
                      className="table analysis-preview-table table-bordered"
                      id="surveyAnalysisReportTable"
                    >
                      <tbody>
                        <tr>
                          <td colSpan={2}>
                            <center>
                              <img
                                src={surveyData.manufacturer__company_logo}
                                style={{
                                  maxHeight: "35px",
                                  margin: "10px",
                                  width: "auto",
                                }}
                              />
                              <br></br>
                              {surveyData.manufacturer__company_name}
                            </center>
                          </td>
                          <td rowSpan={4}>
                            <center>
                              <img
                                src={surveyData.device__device_image}
                                style={{
                                  maxHeight: "150px",
                                  width: "auto",
                                }}
                              />
                            </center>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <center>
                              <strong>{surveyData.survey_name}</strong>
                            </center>
                          </td>
                        </tr>
                        <tr>
                          <td className="width-20">No. of responses</td>
                          <td className="width-60">
                            {surveyData.no_of_responses}
                          </td>
                        </tr>
                        <tr>
                          <td className="width-20">Launch Date</td>
                          <td className="width-60">
                            {get_Date(surveyData.launch_date)}
                          </td>
                        </tr>
                        <tr>
                          <td className="width-20">Completion Date</td>
                          <td className="width-60">
                            {get_Date(surveyData.completion_date)}
                          </td>
                          <td>
                            <center>{surveyData.device__device_name}</center>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="pmcf-content-info1">
                  <div className="row">
                    <div className="col-md-12">{analysisReport}</div>
                  </div>
                  {isNotifyUser == true && isCheckedAccess == true && (
                    <>
                      {surveyData.status === "survey_released"
                        ? isCheckedUser == false && (
                            <>
                              <div className="row m-4">
                                <div className="col-md-6 text-right">
                                  <Link
                                    to="#"
                                    data-toggle="modal"
                                    data-target="#approve_report"
                                    className="btn btn-sm custom-btn-primary"
                                  >
                                    <i className="fa fa-check-square-o"></i>{" "}
                                    Approve Survey
                                  </Link>
                                </div>
                                <div className="col-md-6 tect-left">
                                  <Link
                                    to="#"
                                    data-toggle="modal"
                                    data-target="#reject_report"
                                    className="btn btn-danger btn-sm"
                                  >
                                    <i className="fa fa-close (alias)"></i>{" "}
                                    Reject Survey
                                  </Link>
                                </div>
                              </div>
                            </>
                          )
                        : ""}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserAnalysisReport;
